module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-4-blue.svg";